/**
 * M5 Soviet-era residential visual grammar.
 *
 * These values describe authored, low-detail visual archetypes. They are not
 * claims about the construction system, renovation state, or exact details of
 * any individual source footprint.
 */
export const SOVIET_PANEL_DETAIL_CONFIG = Object.freeze({
  minimumLongFacadeM: 12,
  longFacadeRatio: 0.72,
  plinthHeightM: 0.72,
  plinthDepthM: 0.12,
  floorJointHeightM: 0.025,
  floorJointDepthM: 0.03,
  panelJointWidthM: 0.022,
  panelJointDepthM: 0.025,
  entranceSpacingM: 18,
  maximumEntranceCount: 4,
  entranceWidthM: 1.46,
  entranceHeightM: 2.18,
  entrancePanelOffsetM: 0.16,
  stairwellBandWidthM: 1.18,
  stairwellBandDepthM: 0.045,
  stairwellWindowWidthM: 0.68,
  entranceRevealWidthM: 0.12,
  entranceRevealDepthM: 0.15,
  entranceLightWidthM: 0.34,
  entranceLightHeightM: 0.12,
  canopyWidthM: 2.5,
  canopyHeightM: 0.16,
  canopyDepthM: 0.82,
  entranceLandingWidthM: 2.12,
  entranceLandingDepthM: 1.08,
  entranceLandingHeightM: 0.16,
  entranceStepDepthM: 0.38,
  entranceStepHeightM: 0.08,
  facadeApronDepthM: 1.35,
  facadeApronHeightM: 0.045,
  entranceApproachWidthM: 1.8,
  entranceApproachLengthM: 4.2,
  entranceApproachHeightM: 0.05,
  entranceHandrailHeightM: 0.82,
  entranceHandrailThicknessM: 0.055,
  balconyMinimumWidthM: 1.8,
  balconyMaximumWidthM: 2.75,
  balconyWidthToBayRatio: 0.82,
  maximumBalconyColumnsPerFacade: 6,
  balconyDepthM: 0.92,
  balconySlabHeightM: 0.13,
  balconyFrontHeightM: 0.68,
  loggiaPanelOffsetM: 0.2,
  loggiaPanelDepthM: 0.12,
  loggiaSideDepthM: 0.56,
  parapetHeightM: 0.36,
  parapetDepthM: 0.18,
  roofHousingWidthM: 3.2,
  roofHousingDepthM: 2.35,
  roofHousingHeightM: 1.35,
  roofHousingMinimumInsetM: 2.2,
  maximumRoofHousingCount: 2,
  roofVentSizeM: 0.38,
  roofVentHeightM: 0.7,
  maximumRoofVentCount: 3,
});
